/**
 * Enum to help identify which suggestions action button is selected.
 * {@docCategory Pickers}
 */
export var SuggestionActionType;
(function (SuggestionActionType) {
  /** None of the actions is selected. */
  SuggestionActionType[SuggestionActionType["none"] = 0] = "none";
  /** ForceResolve action is selected. */
  SuggestionActionType[SuggestionActionType["forceResolve"] = 1] = "forceResolve";
  /** SearchMore action is selected. */
  SuggestionActionType[SuggestionActionType["searchMore"] = 2] = "searchMore";
})(SuggestionActionType || (SuggestionActionType = {}));